import styled from 'styled-components'
import { BtnComponent, themeColor } from 'LibNeo'
import { WrapperIcon } from 'LibNeo/components/Basic/Buttons/Button/styled'

export const GridUpBtnContainerStyled = styled.div`
	position: absolute;
	bottom: 40px;
	right: 40px;
`

export const GridUpBtnStyle = styled(BtnComponent)`
	left: 50%;
	background: ${themeColor('white')};
	box-shadow: 0 4px 16px -2px rgba(0, 0, 0, 0.15);
	color: ${themeColor('emerald', 5)};
	pointer-events: auto;
	border-radius: 50%;

	${WrapperIcon} {
		width: 24px;
		height: 24px;
		svg {
			width: 24px;
			height: 24px;
			fill: ${themeColor('gray', 6)};
		}
	}

	&:hover,
	&:focus {
		background: ${themeColor('white')};
		box-shadow: inherit;

		svg {
			fill: ${themeColor('emerald', 5)};
		}
	}

	&:focus,
	&:active {
		outline: 1px solid ${themeColor('emerald', 6)};
	}
`
